module.exports = __webpack_public_path__ + "img/A42E95B027FEFC7AA8CFC9367B167156.a42e95b0.png";